import moment from 'moment';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import { toLocalDateTimeStr } from 'src/shared/utils/localDateTime';
import { ApprovalDetailDto, ApprovalDto, ApprovalType } from './approvalApi';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
const FDR_LDEGER_API_ENABLED = config.servers.fdrledger.enabled;
const FDR_LDEGER_API_URL = config.servers.fdrledger.url;
export interface ScanLedgerOptions {
  sl1?: string; // 회사 이름
  sl2?: string; // 보유 목적
  sl3?: string; // 보유 근거
  sl4?: string; // 열람 제한 사유
  sl5?: string; //수집 방법
  sl6?: string; // 대상 개인
  sl7?: number; // 대상 인원 수
  sl8?: number; // 기록 항목 수
  sl9?: string; // 사용 부서
  sl10_1?: number; // 열람 예정 시작일
  sl10_2?: number; // 열람 예정 종료일
  sl11?: string; // 열람 청구 부서
  sl12?: string; // 열람 제한 항목
  sl13?: string; // 이용 제공 기관
  sl14?: string; // 이용 제공 근거
  sl15?: string; // 이용 제공 항목
}
export interface ScanLedgerServerOptions {
  sl1: string | null; // 회사 이름
  sl2: string | null; // 보유 목적
  sl3: string | null; // 보유 근거
  sl4: string | null; // 열람 제한 사유
  sl5: string | null; //수집 방법
  sl6: string | null; // 대상 개인
  sl7: number | null; // 대상 인원 수
  sl8: number | null; // 기록 항목 수
  sl9: string | null; // 사용 부서
  sl10_1: number | null; // 열람 예정 시작일
  sl10_2: number | null; // 열람 예정 종료일
  sl11: string | null; // 열람 청구 부서
  sl12: string | null; // 열람 제한 항목
  sl13: string | null; // 이용 제공 기관
  sl14: string | null; // 이용 제공 근거
  sl15: string | null; // 이용 제공 항목
}
export enum ScanLedgerUsagesType {
  LEDGER = 'LEDGER',
  EXCEPT = 'EXCEPT',
  EXTEND = 'EXTEND',
}
export interface StartEndDate {
  startDate: number;
  endDate: number;
}
export interface LedgerDocSearchDto {
  code: string;
  name: string;
  path: string;
}
export interface LedgerDocSearchReqDto {
  userId: string;
  requestType: string;
  startDate: number;
  endDate: number;
}
export interface LedgerDocPatterns {
  code: string;
  name: string;
  count: number;
}
export type LedgerDocRuleSets = Omit<LedgerDocPatterns, 'count'>;
export type LedgerDocClassification = Omit<LedgerDocPatterns, 'count'> & {
  color: string;
};
export interface LedgerDocDetailDto {
  code: string; //파일 코드
  name: string; //파일 이름
  path: string; //파일 경로
  ledgerStatus: string;
  /*
  - 관리대장 상태
    NONE: 미작성
    REQUESTED: 작성(신청, 승인대기)
    APPROVED: 승인
    REJECTED: 반려
    EXTEND_REQUESTED: 연장 신청
    EXTEND_APPROVED: 연장 승인
    EXTEND_REJECTED: 연장 반려 
  */
  exceptStatus: string; //
  /*
  - 예외 상태
    NONE: 미작성
    REQUESTED: 작성(신청, 승인대기)
    APPROVED: 승인
    REJECTED: 반려
  */
  deviceCode: string; //장치 코드
  deviceType: string; //장치 종류
  hostname: string; // 장치 이름
  inspectedTimestamp: number; //검사 일시
  formatCode: number; //형식 코드
  patternCount: number; //검출 패턴 수
  patterns: LedgerDocPatterns[]; // 검출 패턴 목록
  rulesets: LedgerDocRuleSets[]; //검출 규정 목록
  classification: LedgerDocClassification; // 분류 라벨 미분류는 null
  encryptionCode: number; //암호화 상태 코드
}
export const defaultLedgerDocSearchReqDto: LedgerDocSearchReqDto = {
  userId: '',
  requestType: 'LEDGER',
  startDate: moment().endOf('day').valueOf(),
  endDate: moment().subtract(1, 'week').valueOf(),
};
export interface ScanLedgerApprovalDto extends ApprovalDto {
  approvalNo: string;

  //제출 유형
  // LEDGER : 관리 대장 작성
  // EXCEPT : 관리 대장 작성 예외
  // EXTEND : 파일 보유 기간 연장
  requestType: string;

  startDate: number; // 파일 보유 기간 시작 시간(long)
  endDate: number; // 파일 보유 기간 종료 시간(long)

  fileSelectAll: string; // 'Y': 파일 전체 선택 / 'N': 파일 전체 선택 안함
  //직접 선택한 대상 파일 목록
  //( fileSelectAll 의 값이 'Y'일 경우 empty array)
  fileList: string[];
  fileStartTs: number; //파일 검출 시작일
  fileEndTs: number; //파일 검출 종료일

  // 관리 대장 작성 sl1~sl15 system 설정에서 설정한 대로 표시
  etcInfos: string; // response 로는 string 값 / request에서는 interface 대로
  etcInfosDTO: ScanLedgerServerOptions;
  //파일 갯수
  fileCnt: number;
  scanLedgerStatus: string;
}
export type ScanLedgerApprovalReqDto = Omit<
  ScanLedgerApprovalDto,
  'userName' | 'userId' | 'approvalNo' | 'scanLedgerStatus' | 'etcInfos' | 'etcInfosDTO' | 'fileCnt'
> & {
  etcInfos: ScanLedgerOptions; // request일 때에는 interface 대로 보내야 한다.
};
export interface ScanLedgerApprovalServerReqDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
  requestType: string;
  fileSelectAll: string; // 'Y': 파일 전체 선택 / 'N': 파일 전체 선택 안함
  //직접 선택한 대상 파일 목록
  //( fileSelectAll 의 값이 'Y'일 경우 empty array)
  fileList: string[];
  fileStartTs: number; //파일 검출 시작일
  fileEndTs: number; //파일 검출 종료일
  // 관리 대장 작성 sl1~sl15 system 설정에서 설정한 대로 표시
  etcInfos: ScanLedgerOptions;
}
export const defaultScanLedgerApprovalItem = (): ScanLedgerApprovalReqDto => {
  return {
    code: '',
    approvalStep: 1,
    currentStep: 1,
    approvalType: ApprovalType.SCANLEDGER,
    status: 'APPLY',
    approvalMethod: 'PRE',
    remark: '',
    approvers: [],
    requestType: ScanLedgerUsagesType.LEDGER,
    startDate: moment().startOf('day').valueOf(),
    endDate: moment().endOf('day').valueOf(),
    fileSelectAll: 'Y',
    fileList: [],
    fileStartTs: moment().startOf('day').valueOf(),
    fileEndTs: moment().endOf('day').valueOf(),
    etcInfos: {} as ScanLedgerOptions,
  };
};
export const convertScanLedgerApprovalReqDtoToServerReq = (
  reqDto: ScanLedgerApprovalReqDto
): ScanLedgerApprovalServerReqDto => {
  return {
    code: reqDto.code,
    approvalStep: reqDto.approvalStep,
    currentStep: reqDto.currentStep,
    approvalType: reqDto.approvalType,
    status: reqDto.status,
    approvalMethod: reqDto.approvalMethod,
    remark: reqDto.remark,
    approvers: reqDto.approvers,
    startDate: reqDto.startDate,
    endDate: reqDto.endDate,
    //관리대장
    requestType: reqDto.requestType,
    fileSelectAll: reqDto.fileSelectAll,
    fileList: reqDto.fileList,
    fileStartTs: reqDto.fileStartTs,
    fileEndTs: reqDto.fileEndTs,
    etcInfos: reqDto.etcInfos,
  };
};
export interface ScanLedgerApprovalDetailDto extends ApprovalDetailDto {
  //ApprovalDetail Dto

  ////

  userIp: number;
  startDate: number;
  endDate: number;
  scanLedgerStatus: string;

  requestType: ScanLedgerUsagesType;
  fileSelectAll: string; // 'Y': 파일 전체 선택 / 'N': 파일 전체 선택 안함
  //직접 선택한 대상 파일 목록
  //( fileSelectAll 의 값이 'Y'일 경우 empty array)
  fileList: string[];
  fileStartTs: number; //파일 검출 시작일
  fileEndTs: number; //파일 검출 종료일
  // 관리 대장 작성 sl1~sl15 system 설정에서 설정한 대로 표시

  fileCnt: number;
  etcInfos: ScanLedgerServerOptions;
  // etcInfosDTO: ScanLedgerServerOptions;
}
export interface ScanLedgerApprovalDetailEntity extends ScanLedgerApprovalDetailDto {
  startDateStr: string;
  endDateStr: string;
  applyDateStr: string;
  updatedTsStr: string;
}
export const toScanLedgerApprovalDetailDtoToEntity = (
  dto: ScanLedgerApprovalDetailDto
): ScanLedgerApprovalDetailEntity => {
  return {
    ...dto,
    startDateStr: dto.startDate > 0 ? toLocalDateTimeStr(dto.startDate) : '',
    endDateStr: dto.endDate > 0 ? toLocalDateTimeStr(dto.endDate) : '',
    applyDateStr: dto.applyDate > 0 ? toLocalDateTimeStr(dto.applyDate) : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateTimeStr(dto.updatedTs) : '',
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
export interface ScanLedgerUsageFilesItem {
  code: string;
  name: string;
  path: string;
  removed: boolean;
  revoked: boolean;
}
export interface ScanLedgerUsageFilesDto {
  count: number;
  files: ScanLedgerUsageFilesItem[];
}
export type ScanLedgerUsageFilesEntity = ScanLedgerUsageFilesDto;
const toEntityScanLedgerUsageFiles = (dto: ScanLedgerUsageFilesDto): ScanLedgerUsageFilesEntity => {
  return {
    ...dto,
  };
};
interface ScanLedgerApprovalApi {
  find(code: string): Promise<ScanLedgerApprovalDetailEntity>;
  apply(reqDto: ScanLedgerApprovalReqDto): Promise<ScanLedgerApprovalDto>;
  cancel(approvalNo: string): Promise<boolean>;
  documentList(
    conditions: LedgerDocSearchReqDto,
    offset: number,
    limit: number
  ): Promise<LedgerDocSearchDto[]>;
  documentDetail(fileCode: string): Promise<LedgerDocDetailDto>;
  usageFiles(approvalNo: string, page: number, limit: number): Promise<ScanLedgerUsageFilesEntity>;
}
class ScanLedgerApprovalServerApi implements ScanLedgerApprovalApi {
  async documentDetail(fileCode: string): Promise<LedgerDocDetailDto> {
    const resp = await axios.get<LedgerDocDetailDto>(
      `${FDR_LDEGER_API_URL}/api/file/detail/${fileCode}`
    );
    return resp.data;
  }
  async documentList(
    conditions: LedgerDocSearchReqDto,
    offset: number,
    limit: number
  ): Promise<LedgerDocSearchDto[]> {
    // const resp = await axios.get<LedgerDocSearchDto[]>(`${FXM_API_URL}/api/organs/tree2?onlyDept=N&root=Y`);
    const resp = await axios.get<LedgerDocSearchDto[]>(
      `${FDR_LDEGER_API_URL}/api/file/request/${conditions.userId}`,
      {
        params: {
          'req-type': conditions.requestType,
          'start-inspectts': conditions.startDate,
          'end-inspectts': conditions.endDate,
          page: offset,
          limit: limit,
        },
      }
    );
    return resp.data;
  }
  async find(code: string): Promise<ScanLedgerApprovalDetailEntity> {
    const resp = await axios.get<ScanLedgerApprovalDetailDto>(
      `${FXM_API_URL}/api/scanledger/find/${code}`
    );
    return toScanLedgerApprovalDetailDtoToEntity(resp.data);
  }
  async apply(reqDto: ScanLedgerApprovalReqDto): Promise<ScanLedgerApprovalDto> {
    const serverReqDto: ScanLedgerApprovalServerReqDto =
      convertScanLedgerApprovalReqDtoToServerReq(reqDto);
    const resp = await axios.post<ScanLedgerApprovalDto>(
      `${FXM_API_URL}/api/scanledger/apply`,
      serverReqDto
    );
    return resp.data;
  }
  async cancel(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<ScanLedgerApprovalDetailDto>(
      `${FXM_API_URL}/api/scanledger/cancel/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
  async usageFiles(
    approvalNo: string,
    page: number,
    limit: number
  ): Promise<ScanLedgerUsageFilesEntity> {
    const resp = await axios.get<ScanLedgerUsageFilesDto>(
      `${FDR_LDEGER_API_URL}/api/file/approval/${approvalNo}`,
      {
        params: {
          offset: (page - 1) * limit,
          limit: limit,
        },
      }
    );
    return toEntityScanLedgerUsageFiles(resp.data);
  }
}
const scanLedgerApprovalApi = new ScanLedgerApprovalServerApi();
export default scanLedgerApprovalApi;
